import { render, staticRenderFns } from "./AnagraficaRegionaleTestComponent.vue?vue&type=template&id=df2ee894"
import script from "./AnagraficaRegionaleTestComponent.vue?vue&type=script&lang=js"
export * from "./AnagraficaRegionaleTestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports